// extracted by mini-css-extract-plugin
module.exports = {"ul":"Paginated_ul__1v-5b","numberBtn":"Paginated_numberBtn__3A6ZC","btn":"Paginated_btn__20MKA"};